import React, { FC } from 'react';

import { useDisplayLanguage } from '@/shared/hooks/useDisplayLanguage';
import { clientConfig } from '@/config/client';

import { LanguageOption } from '../../types/watchingSettings';
import { SettingsDropdown } from '../SettingsDropdown/SettingsDropdown';
import { useI18n } from '../../hooks/useI18n';
import { Cell } from '../Cell/Cell';

const {
    i18n: { displayLanguages },
} = clientConfig;

export const DisplayLanguageSetting: FC = () => {
    const i18n = useI18n();

    const [displayLanguage, setDisplayLanguage] = useDisplayLanguage();

    const onDisplayLanguageChange = (option: LanguageOption) => {
        setDisplayLanguage(option.code);
    };

    if (!displayLanguages) {
        return null;
    }

    return (
        <Cell
            title={i18n('display_language__title')}
            description={i18n('display_language__description')}
        >
            <SettingsDropdown
                defaultDropdownButtonTitle={i18n('display_language__dropdown_title')}
                selectedOptionTitle={displayLanguage?.title}
                options={displayLanguages}
                onChangeOption={onDisplayLanguageChange}
            />
        </Cell>
    );
};
